export default "__VITE_ASSET__CBlh2OOz__"